import { SHORTCUT_MAIN_PAGE_CONFIG_FIELDS } from '@@partner:graphql/shortcuts'
import { RemoteMainPageConfig } from '@@partner:types:app'
import { PageInfo, NestedFilter, CommonSort, CommonPager } from '@@partner:types:graphql'
import { gql, useQuery, useLazyQuery } from '@apollo/client'



export interface AllMainPageConfigsQuery {
  allMainPageConfigs: {
    edges: RemoteMainPageConfig[]
    pageInfo: PageInfo
  }
}
export interface AllMainPageConfigsQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}
export const GQL_QUERY_ALL_MAIN_PAGE_CONFIGS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allMainPageConfigs(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_MAIN_PAGE_CONFIG_FIELDS}
      }
      pageInfo {
        page
        perPage
        lastPage
        next
        total
      }
    }
  }
`
export const useFetchAllMainPageConfigs = (variables: AllMainPageConfigsQueryVariables) =>
  useQuery<AllMainPageConfigsQuery, AllMainPageConfigsQueryVariables>(
    GQL_QUERY_ALL_MAIN_PAGE_CONFIGS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
export const useLazyFetchAllMainPageConfigs = (variables?: AllMainPageConfigsQueryVariables) =>
  useLazyQuery<AllMainPageConfigsQuery, AllMainPageConfigsQueryVariables>(GQL_QUERY_ALL_MAIN_PAGE_CONFIGS, {
    variables
  })